<template>
  <div id="assignment-info">
    <div class="base-create">
      <el-row class="info-row mb-px-24">
        <el-col :span="3">
          <span class="label">
            {{ isCompanyOrg ? $t("company_labels.group") : $t("assignments.details.class") }}</span
          >
        </el-col>
        <el-col :span="21">
          <div>
            <p>
              <span class="value">{{ className }}</span>
            </p>
          </div>
        </el-col>
      </el-row>
      <el-row class="mb-px-24 info-row">
        <el-col :span="3">
          <span class="label">{{ $t("assignments.details.timeline") }}</span>
        </el-col>
        <el-col :span="21">
          <div v-if="!editMode">
            <div class="timeline">
              <span class="value">{{ formatDate(timeLine.startDate) }}</span>
              <span class="value">-</span>
              <span class="value">{{ formatDate(timeLine.dueDate) }}</span>
              <span class="edit-timeline" @click="editTimeline" :title="$t('assignments.details.edit_timeline')">
                <i class="elsa-icon-edit2" />
              </span>
            </div>
          </div>
          <div v-else>
            <el-form :inline="true" class="timeline-edit" ref="firstForm">
              <el-form-item>
                <el-col :span="11">
                  <elsa-date
                    :disabled="disabledStartDate"
                    v-model="form.startDate"
                    @change="changeStartDate"
                    value-format="yyyy-MM-dd"
                    :format="dateFormat"
                    type="date"
                    name="startDate"
                    :class="'elsa-input ' + classDisableStartDate"
                    placeholder="dd/mm/yy"
                    :picker-options="pickerOptions"
                  >
                  </elsa-date>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <elsa-date
                    v-model="form.dueDate"
                    value-format="yyyy-MM-dd"
                    :format="dateFormat"
                    @change="changeDueDate"
                    type="date"
                    name="dueDate"
                    class="elsa-input"
                    placeholder="dd/mm/yy"
                    :picker-options="pickerOptions"
                  >
                  </elsa-date>
                </el-col>
              </el-form-item>
              <el-form-item class="edit-check-group">
                <span class="edit-timeline" @click="updateTimeline">
                  {{ $t("assignments.details.confirm") }}
                </span>
                <span class="cancel-edit" @click="cancelUpdate">
                  {{ $t("assignments.details.cancel") }}
                </span>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
      <el-row class="mb-px-32 info-row">
        <el-col :span="3">
          <span class="label">{{ $t("assignments.details.reminder_sent") }}</span>
        </el-col>
        <el-col :span="12">
          <div>
            <p>
              <span class="value">{{ $t("assignments.details.days", [reminderSent]) }}</span>
              <span>{{ $t("assignments.details.before_due") }}</span>
            </p>
          </div>
        </el-col>
      </el-row>
      <div v-for="(item, index) in studySets" :key="item.id">
        <el-row class="mb-px-16 mt-px-16">
          <el-col :span="2">
            <div class="icon-column">
              <book-icon width="50px" />
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-column pl-px-16">
              <p>
                <span class="label">{{ $t("assignments.details.study_set_name", { idx: index + 1 }) }}</span>
                <br />
                <span class="value">{{ item.name }}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="info-column pl-px-24">
              <p>
                <span class="label">{{ $t("assignments.details.count_of_items") }}</span>
                <br />
                <span class="value">{{ item.phrases_count }}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="info-column pl-px-40">
              <p>
                <span class="label">{{ $t("assignments.details.category") }}</span>
                <br />
                <span class="value">{{ item.category }}</span>
              </p>
            </div>
          </el-col>
        </el-row>
        <hr v-if="index < studySets.length - 1" />
      </div>
    </div>
  </div>
</template>
<script>
import bookIcon from "@/assets/images/inline.book-icon.svg";
import { format } from "date-fns";
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";
import { mapGetters } from "vuex";
import ElsaDate from "@/components/common/dateInput";
import { DATE_FORMAT } from "@/constants/generic";
import { path } from "ramda";
import { COMPANY } from "@/constants/organizationType";
export default {
  components: {
    bookIcon,
    ElsaDate,
  },
  props: {
    studySets: {
      type: Array,
      default: () => [{}],
    },
    reminderSent: {
      type: Number,
      default: 2,
    },
    timeLine: {
      type: Object,
      default: () => ({}),
    },
    dateFormat: {
      type: String,
      default: DATE_FORMAT,
    },
    className: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 1 * 86400000;
        },
      },
      form: {
        startDate: "",
        dueDate: "",
      },
      editMode: false,
      disabledStartDate: false,
      classDisableStartDate: "",
      payload: null,
      timeFormat: "HH:mm",
    };
  },
  computed: {
    ...mapGetters({
      currentOrganization: "organization/currentOrganization",
      currentOrganizationType: "organization/currentOrganizationType",
    }),
    getTimeLine() {
      return this.timeLine;
    },
    isCompanyOrg() {
      return this.currentOrganizationType === COMPANY
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return "--";
      let timeZone = this.currentOrganization.timezone;
      const zonedDate = utcToZonedTime(date, timeZone);
      return format(zonedDate, this.dateFormat);
    },
    editTimeline() {
      this.editMode = true;
      let timeZone = this.currentOrganization.timezone;
      this.form.startDate = utcToZonedTime(path(["getTimeLine", "startDate"])(this), timeZone);
      this.form.dueDate = utcToZonedTime(path(["getTimeLine", "dueDate"])(this), timeZone);
      if (new Date(this.form.startDate) < Date.now()) {
        this.disabledStartDate = true;
        this.classDisableStartDate = "disable-start-date";
      }
      return true;
    },
    updateTimeline() {
      this.editMode = false;
      if (this.payload) {
        this.$emit("update-timeline", this.payload);
        this.payload = null;
      }
    },
    cancelUpdate() {
      this.editMode = false;
    },
    changeDueDate() {
      let timeZone = this.currentOrganization.timezone;
      const zonedDueDate = utcToZonedTime(this.timeLine.dueDate, timeZone);
      let dueTimeLocal = format(zonedDueDate, this.timeFormat);
      this.payload = { ...this.payload, due_date: zonedTimeToUtc(this.form.dueDate + " " + dueTimeLocal, timeZone) };
    },
    changeStartDate() {
      let timeZone = this.currentOrganization.timezone;
      const zonedStartDate = utcToZonedTime(this.timeLine.startDate, timeZone);
      let startTimeLocal = format(zonedStartDate, this.timeFormat);
      this.payload = {
        ...this.payload,
        start_date: zonedTimeToUtc(this.form.startDate + " " + startTimeLocal, timeZone),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/_colors.scss";
#assignment-info {
  background: #ffffff;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 32px 24px 0px;
  margin-bottom: 24px;
}

.info-row {
  p,
  span.label,
  .timeline,
  .timeline-edit {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #757575;
    margin: 0;
    text-align: initial;
  }

  .value {
    color: $black;
    text-transform: none;
    margin-bottom: 4px;
    padding-right: 25px;
  }
}

.info-column {
  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: $black;
    margin: 0;
    text-align: initial;
  }

  .value {
    color: $black;
    text-transform: none;
    margin-bottom: 4px;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }
}

.icon-column {
  padding: 12px 0px 0px 12px;
}
::v-deep .elsa-input .el-input .el-input__inner {
  width: 120px;
  font-weight: 600;
  color: $black;
  opacity: 1;
}
::v-deep .el-date-editor.el-input {
  width: 120px;
}
::v-deep .el-form .el-form-item {
  flex-direction: row;
  margin-bottom: 0px;
}
::v-deep .el-form .el-form-item .el-form-item__label {
  width: 80px;
}
.timeline {
  display: flex;
  justify-content: flex-start;
  padding-bottom: 0px;
}
.timeline-edit {
  display: flex;
  justify-content: flex-start;
  padding-bottom: 0px;
}
::v-deep .disable-start-date .el-input .el-input__inner {
  background: #e6e6e6 !important;
}
.timeline,
.timeline-edit {
  .elsa-input {
    margin-top: -18px;
  }
  .line {
    text-align: center;
    font-weight: 600;
  }
  .edit-check-group {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    margin-right: -28px;
    margin-top: -3px;
  }
}
.edit-timeline {
  color: #478dff;
  cursor: pointer;
  padding: 0px 10px;
  margin-top: -6px;
}
.cancel-edit {
  cursor: pointer;
}
</style>
